const path = '$contact';

//
// ────────────────────────────────────────────────────── I ──────────
//   :::::: C O N T A C T : :  :   :    :     :        :          :
// ────────────────────────────────────────────────────────────────
//

export const CURRENT_CONTACT_ITEM = `${path}/contact/current/item`;
export const CONTACT_LIST = `${path}/contact/list`;
export const CONTACT_LIST_NEXT = `${path}/contact/list/next`;
export const CONTACT_LIST_FILTER = `${path}/contact/list/filter`;
export const CONTACT_DETAIL = `${path}/contact/detail`;
export const CONTACT_SELECT = `${path}/contact/select`;
export const CONTACT_SELECT_ALL = `${path}/contact/select/all`;
export const CONTACT_SELECT_CLEAR = `${path}/contact/select/clear`;
export const CONTACT_SELECTION = `${path}/contact/selection`;
export const CONTACT_ADD = `${path}/contact/add`;
export const CONTACT_EDIT = `${path}/contact/edit`;
export const CONTACT_COPY = `${path}/contact/copy`;
export const CONTACT_MOVE = `${path}/contact/move`;
export const CONTACT_DELETE = `${path}/contact/delete`;
export const CONTACT_DOWNLOAD = `${path}/contact/download`;
export const CONTACT_SELECT_DOWNLOAD = `${path}/contact/download/select`;
export const CONTACT_UPLOAD = `${path}/contact/upload`;
export const CONTACT_NEW = `${path}/contact/new`;
export const CONTACT_SHARE = `${path}/contact/share`;
export const CONTACT_SHARE_TARGET = `${path}/contact/share/target`;
export const CONTACT_SHARE_ADD = `${path}/contact/share/add`;
export const CONTACT_SHARE_REMOVE = `${path}/contact/share/remove`;